export const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
  'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export const getPreviousMonthYear = ({ month, year }) =>
  ((month > 0) ? {
    month: month - 1,
    year,
  } : {
    month: 11,
    year: year - 1,
  });

export const getNextMonthYear = ({ month, year }) =>
  ((month < 11) ? {
    month: month + 1,
    year,
  } : {
    month: 0,
    year: year + 1,
  });

export const getSteppedMonthYear = ({ month, year, step }) => {
  if (step > 1 || step < -1) throw Error('Step should be -1, 0 or 1');
  if (step === 1) {
    return getNextMonthYear({ month, year });
  }
  if (step === -1) {
    return getPreviousMonthYear({ month, year });
  }
  return { month, year };
};

export const parseN = number => String(number).padStart(2, '0');
